import QuizIcon from '@mui/icons-material/Quiz';
import { IconButton, Tooltip, tooltipClasses, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { pdfPages} from '../../constants/userAccess';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#4a4949",
    color: "#fff",
    fontSize: "13px",
    padding: "6px 12px",
    borderRadius: "16px",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#4a4949",
  },
}));

const HelpButton = ({ currentPage }) => {

  const handleClick = () => {
    const { page } = pdfPages[currentPage] || {};
    const pdfUrl = `/User_Access_Management.pdf#page=${page}`;
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Box>
      <CustomTooltip title="Click for Help" arrow placement="left">
        <IconButton
          onClick={handleClick}
          sx={{
            height: 45,
            width: 45,
            position: "fixed",
            bottom: 30,
            right: 32,
            backgroundColor: "#000",
            color: "#fff",
            zIndex: 1400,
            "&:hover": {
              backgroundColor: "#4a4949",
            },
          }}
        >
          <QuizIcon sx={{ fontSize: 25 }} />
        </IconButton>
      </CustomTooltip>
    </Box>
  );
};

export default HelpButton;